import React, { Children } from 'react'
import { Ghost, Separator } from '@fs/zion-ui'
import { CardCarousel, cardHeadingMap, NewCard } from '../../../lib/card'
import {
  getCreatorsNames,
  getCustomImage,
  getIsPastBroadcast,
  isExternalUrl,
  getPercentageWatched,
  getDuration,
} from '../../../lib/helpers'
import { getIsPlaylistable } from '../../../hooks'
import { SectionCard } from '../../../lib/section-card'

const HorizontalCardGrid = ({
  items,
  heading,
  as = 'h3',
  defaultDuration,
  actions,
  sectionDescription,
  flavor = 'mango',
}) => {
  return (
    <div>
      <SectionCard
        heading={heading}
        flavor={flavor}
        actions={actions}
        description={sectionDescription}
        headingLevel={as}
      >
        <Separator size="xxs" />
        <CardCarousel>
          {Children.toArray(
            items
              ?.filter((session) => session.item?.title || session.title)
              ?.map((session) => {
                const { date, isLive, item } = session
                const { title, creators, description, url, sessionUrl, conferenceYear } = item ?? session
                const videoDuration = getDuration(item ?? session)
                const percentageWatched = getPercentageWatched(item ?? session)
                const duration =
                  defaultDuration && (!videoDuration || videoDuration === '0:00') ? defaultDuration : videoDuration
                const { contentLocale } = item?.video ?? session ?? {}
                const actualUrl = url ?? sessionUrl
                return (
                  <Ghost keepVisible style={{ flexGrow: 1 }}>
                    <NewCard
                      contentId={session?.contentId ?? item?.contentId ?? session?.id ?? item?.id}
                      isPlaylistable={getIsPlaylistable({
                        contentType: session?.contentType || session?.promo?.contentType || item?.contentType,
                      })}
                      image={getCustomImage(item ?? session)}
                      maxImageHeight="200px"
                      heading={title}
                      description={getCreatorsNames(creators) ?? description}
                      isLive={isLive}
                      to={actualUrl}
                      contentLocale={contentLocale}
                      duration={duration}
                      external={isExternalUrl(url ?? sessionUrl)}
                      startTimestamp={!getIsPastBroadcast({ date, videoDuration: duration }) ? date : undefined}
                      conferenceYear={conferenceYear}
                      percentageWatched={percentageWatched}
                      headingLevel={cardHeadingMap[as]}
                      item={session}
                    />
                  </Ghost>
                )
              })
          )}
        </CardCarousel>
      </SectionCard>
    </div>
  )
}

export default HorizontalCardGrid
